export default __webpack_public_path__ + "static/media/confirmed.86179060.svg";